export const DOUGHNUT_CHART_COLOR = {
  BLUE: 'rgba(18, 164, 255, 1)',
  PURPLE: 'rgba(118, 95, 226, 1)',
  GRAY: 'rgba(227, 227, 234, 1)'
}